// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M11.9994 0.801758L18.0527 4.79461L17.0007 6.38954V9.4997L20.3352 11.9998H22.002V13.9998H21.002V21.9998H13V17H11V21.9998H3.00195V13.9998H2.00195V11.9998H3.66853L7.00065 9.4999V6.38918L5.94855 4.79491L11.9994 0.801758ZM15.6674 10.9998H8.33407L7.00117 11.9998H17.0012L15.6674 10.9998ZM13.0059 4.99805H11.002V7.00195H13.0059V4.99805Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-city-ancient-2-filled')
export default class CityAncient2FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'city-ancient-2-filled',
    }
  }
}
